<script lang="ts">
  import { faq } from "../lib/stores/FAQ";
</script>

<main class="bg-cover bg-no-repeat bg-[center_top] bg-[url('/bg/mobile-bg51.webp')] tabletLg:bg-none tabletLg:bg-dark flex-col grow relative bg-dark content-center text-white">
  <div class={[
    "absolute w-full z-[1] hidden tabletLg:block top-0",
    "before:content-[''] before:absolute before:bottom-0 before:left-0 before:right-0 before:h-[100px]",
    "before:bg-gradient-to-b before:from-transparent before:to-dark",
    "before:pointer-events-none"
  ].join(' ')}>
    <img src="/bg/primary-bg.webp" alt="" class="w-full h-full object-cover">
  </div>
  <div class="flex mx-4 my-4 mb-[calc(118px+1rem)] laptop:mb-4 p-4 flex-col bg-black/50 rounded-lg tablet:w-[80vw] tablet:mx-auto relative z-[2]">
    <h1 class="font-MrEavesXLSanNarOTUltra text-[32px] text-center">{@html $faq.title}</h1>
    <h2 class="font-MrEavesXLSanNarOTUltra text-[24px] text-center">{$faq.subtitle}</h2>
    <ol class="font-MrEavesXLSanNarOT text-[20px] px-[2rem] list-decimal">
      {#each $faq.qaList as qaItem}
        <li class="my-[2rem] px-[1rem]">
          <h3 class="font-MrEavesXLSanNarOTUltra my-[0.5rem]"><span class="mr-[0.5rem]">{$faq.q}</span> {@html qaItem.question}</h3>
          {#each qaItem.answer as answerItem, index}
            {#if index === 0}
              <p class="mb-[1rem]"><span class="mr-[0.5rem]">{$faq.a}</span> {@html answerItem.content}</p>
            {:else if answerItem.type === 'string'}
              <p class="mb-[1rem]">{@html answerItem.content}</p>
            {:else if answerItem.type === 'list'}
              <ul class="list-disc my-[1rem] ml-[2rem]">
                {#each answerItem.content as listItem}
                  <li class="px-[1rem]">{@html listItem}</li>
                {/each}
              </ul>
            {/if}
          {/each}
        </li>
      {/each}
    </ol>

    <p>{@html $faq.footnote}</p>
  </div>
</main>
